<template>
</template>
<script>
  export default {
    props: {
      cdn: {
        default() {
          return {
            url: 'https://cdn.vevanta.ru/',
            dinamyc: false,
          }
        }
      },

      settingsProjects: {
        default() {
          return {
            514: {
              price: 5400000
            },

            515: {
              price: 4800000
            },

            516: {
              price: 4700000
            },

            517: {
              price: 4100000
            },

            518: {
              price: 3900000
            }
          }
        }
      },

      messangers: {
        default() {

          return [
            {
              img: 'https://cdn.vevanta.com/sk/4.png',
              src: 'https://t.me/AntonovBro',
              target: '',
            },

            {
              img: 'https://cdn.vevanta.com/sk/whatsapp.png',
              src: 'https://wa.me/79323212510?text=Здравствуйте%2C+у+меня+есть+вопрос',
              target: '',
            },

            {
              img: 'https://cdn.vevanta.com/sk/viber.png',
              src: 'viber://chat?number=79323212510',
              target: '',
            },

          ]
        }
      },

      contacts: {
        default() {
          return {
            phone: '+7 (3452) 39-65-71',
            email: 'vevanta@yandex.ru',
          }
        }
      },

      form: {
        default() {
          return {
            politica: {
              val: '/politika-konfidencialnosti',
              target: '_blank',
            }
          }
        }
      },

      api: {
        default() {
          return {
            url: ''
          }
        }
      },

      config: {
        default() {
          return {

            yandex: {
              id: '',
            },

            form: {
              url: 'mail/vevanta',
              bitrix: {
                sourceId: '',
                staffId: '',
                companyId: '',
              }

            }
          }
        }
      }


    },
    created() {
      this.$store.dispatch('SET_MESSANGERS', this.messangers)
      this.$store.commit('SET_SETTINGS_PROJECTS', this.settingsProjects)
      this.$store.dispatch('SET_CDN', this.cdn)
      this.$store.dispatch('SET_CONFIG', this.config)
      this.$store.dispatch('SET_FORM', this.form)
      this.$store.dispatch('SET_CONTACTS', this.contacts)
      this.$store.dispatch('SET_API', this.api)
    }
  }
</script>
